import { render, staticRenderFns } from "./usb.vue?vue&type=template&id=60975342"
import script from "./usb.vue?vue&type=script&lang=js"
export * from "./usb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports